import faqCategory from './faq-category'
import postCategory from './post-category'
import themeCategory from './theme-category'

export default {
  name: 'baseInfo',
  path: 'base-info',
  meta: {
    label: 'baseInfo',
    auth: 'baseInfo'
  },
  component: {
    name: 'BaseInfo',
    render(c) {
      return c('router-view')
    }
  },
  children: [faqCategory, postCategory, themeCategory]
}
